import { paginate, RangePagination, RangePaginationState } from 'components/basic/Pagination';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import '../../../../../styles/Icons.scss';
import { DataCell, DataRow, DataTable, DataTableButton } from '../../../../basic/DataTable';
import { MaterialIcon } from '../../../../basic/Icon';
import { handleValueChange } from '../generic/Handlers';
import StageActionToolbar from '../generic/StageActionToolbar';


interface PolicyDetailsEquipmentFloaterStagingPageArgs {
    conversionId: string,
}

type PolicyDetailsEquipmentFloaterStagingPageProps = RouteComponentProps<PolicyDetailsEquipmentFloaterStagingPageArgs>;

interface PolicyDetailsEquipmentFloaterStagingPageState {
    destinationCodes: any;
    filter: string;

    pagination: RangePaginationState;
}

export class PolicyDetailsEquipmentFloaterStagingPage extends React.Component<PolicyDetailsEquipmentFloaterStagingPageProps, PolicyDetailsEquipmentFloaterStagingPageState>{

    constructor(props: PolicyDetailsEquipmentFloaterStagingPageProps) {
        super(props)
        this.state = {
            destinationCodes: [],
            filter: '',

            pagination: {
                pageSize: 25,
                pageNumber: 0,
            }
        }
    }

    componentDidMount() {
        //this.client.get(this.props.match.params.conversionId, '')
        //    .then((response) => {
        //        this.setState({
        //            items: response!
        //        })
        //    })
        //    .catch(error => { })
    }


    public render() {
        const conversionId = this.props.match.params.conversionId;
        //const items = this.state.items;
        return (
            <>
                <StageActionToolbar
                    conversionId={conversionId}
                    sectionId='equipmentfloater'
                    tierGate='tier4'
                    noMapping={true}
                    filter={this.state.filter}
                />
                {
                    //this.dataTable(items)
                    //this.pagination(items)
                }
                
                
            </>
        );
    }
}